import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Box,
  Grid,
  Paper,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import { FaSadTear } from "react-icons/fa";
import config from "../../Config";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const DeleteAccount = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    reason: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      formData.name &&
      formData.email &&
      formData.contactNumber &&
      formData.reason
    ) {
      setLoading(true);
      try {
        const apiUrl = `${config.apiBaseUrl}/${config.deleteUserAccount}`;
        const response = await fetch(apiUrl, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            contact: formData.contactNumber,
            reason: formData.reason,
          }),
        });

        if (!response.ok) {
          throw new Error(
            "Failed to process your request. Please try again later.",
          );
        }

        setIsSubmitted(true);
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setLoading(false);
      }
    } else {
      setOpenSnackbar(true);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(to bottom, #ff69b4, #ffffff)",
      }}
    >
      <Navbar />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <Paper elevation={3} sx={{ padding: 3, maxWidth: 500, width: "100%" }}>
          <Typography variant="h5" gutterBottom align="center">
            Delete Account Request
          </Typography>

          {!isSubmitted && (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Full Name"
                    variant="outlined"
                    fullWidth
                    required
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    required
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Contact Number"
                    variant="outlined"
                    fullWidth
                    required
                    name="contactNumber"
                    type="tel"
                    value={formData.contactNumber}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Reason for Deletion"
                    variant="outlined"
                    fullWidth
                    required
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    multiline
                    rows={4}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    type="submit"
                    fullWidth
                    disabled={loading}
                    sx={{
                      background: "linear-gradient(to right, #ff69b4, #ff1493)",
                      "&:hover": {
                        background:
                          "linear-gradient(to right, #ff69b4, #ff1493)",
                      },
                    }}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}

          {isSubmitted && (
            <Box sx={{ textAlign: "center", marginTop: 2 }}>
              <FaSadTear size={50} />
              <Typography
                variant="h6"
                color="textSecondary"
                sx={{ marginTop: 2 }}
              >
                We're sorry to see you go.
              </Typography>
              <Typography variant="body1" sx={{ marginTop: 1 }}>
                Your account will be deleted within 3-4 working days. If you
                change your mind, you can contact us before the process
                completes.
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>

      <Footer />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message="Please fill out all fields before submitting."
        severity="error"
      />

      {errorMessage && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          onClose={() => setErrorMessage("")}
          message={errorMessage}
          severity="error"
        />
      )}
    </Box>
  );
};

export default DeleteAccount;
